import styled from 'styled-components';
import { Tabs as AntdTabs } from 'antd';
import theme from '../theme';

export const StyledPrimaryTabs = styled(AntdTabs)`
  .ant-tabs-nav {
    background-color: white;
    padding: 0 25px;
  }
`;

export const StyledPrimaryTabBar = styled.div`
  background-color: ${theme.white};
  && {
    box-shadow: ${theme.getElevation('bottom')};
    > div {
      margin-bottom: 0;
    }
    .ant-tabs-tab {
      &,
      &:focus,
      &:active {
        > * {
          color: ${theme.getColor('textSecondary')};
        }
      }
    }
    .ant-tabs-tab-active {
      &,
      &:focus,
      &:active {
        > * {
          color: ${theme.getColor('textPrimary')};
        }
      }
    }
  }
`;

export const StyledTabPane = styled(AntdTabs.TabPane)<{ $width?: number }>`
  > div > div {
    ${({ $width }) => $width && `width: ${$width}px`};
  }
`;
